import { render, staticRenderFns } from "./AdsPlace.vue?vue&type=template&id=47daad7c"
import script from "./AdsPlace.vue?vue&type=script&lang=js"
export * from "./AdsPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports